(function() {
  function initFeaturedCollection() {
    // Intersection Observer for scroll fade-in animations
    const fadeElements = document.querySelectorAll('.fade-in-scroll:not(.is-visible)');
    
    if (fadeElements.length > 0) {
      const fadeObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.1
      });

      fadeElements.forEach(element => {
        fadeObserver.observe(element);
      });
    }

    // Slider functionality
    const sliderContainers = document.querySelectorAll('.slider-container:not(.js-bound)');
    sliderContainers.forEach(container => {
      container.classList.add('js-bound');
      const grid = container.querySelector('.product-grid');
      const nextBtn = container.querySelector('.slider-arrow--next');
      const prevBtn = container.querySelector('.slider-arrow--prev');
      
      if (grid && nextBtn && prevBtn) {
        nextBtn.addEventListener('click', () => {
          grid.scrollBy({ left: grid.clientWidth * 0.75, behavior: 'smooth' });
        });
        prevBtn.addEventListener('click', () => {
          grid.scrollBy({ left: -grid.clientWidth * 0.75, behavior: 'smooth' });
        });
      }
    });

    // Hover Size button routing (redirect to product page for now)
    const sizeButtons = document.querySelectorAll('.size-btn:not(.js-bound)');
    sizeButtons.forEach(button => {
      button.classList.add('js-bound');
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const url = button.closest('.product-card').querySelector('.product-card__title a').href;
        if(url) window.location.href = url;
      });
    });
  }

  // Run initialization immediately (since the script is deferred)
  initFeaturedCollection();

  // Re-run on Shopify Theme Editor events to support live editing
  document.addEventListener('shopify:section:load', initFeaturedCollection);
})();
